<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="bg-grey-lighten-4 elevation-0">
          <v-toolbar color="primary" density="comfortable">
            <v-toolbar-title class="text-white">
              {{ title }}
            </v-toolbar-title>
            <v-spacer />
            <div class="d-flex ga-2">
              <v-tooltip location="left" text="Fermer">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" @click="cancel">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>

              <v-tooltip location="left" text="Télécharger">
                <template #activator="{ props }">
                  <v-btn icon variant="text" v-bind="props" @click="download">
                    <v-icon>mdi-file-download-outline</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>

              <v-tooltip location="left" text="Imprimer">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" @click="print">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>

              <v-tooltip location="left" text="Sauvegarder">
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" @click="save">
                    <v-icon>mdi-content-save-all</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>

              <v-tooltip location="left" text="Ajouter un avenant">
                <template #activator="{ props }">
                  <v-btn
                    v-bind="props"
                    icon
                    variant="text"
                    :disabled="isCreatingNewLaverie"
                    @click="createNewAvenant"
                  >
                    <v-icon>mdi-pen-plus</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </div>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>

    <!-- Expansion panels -->
    <v-expansion-panels multiple>
      <!-- Compte siège -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Compte siège</span>
          <template #actions>
            <v-icon v-if="siegePanelCompleted" color="teal">mdi-check</v-icon>
          </template>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="6">
              <v-text-field
                v-if="accountName"
                label="Siège"
                disabled
                v-model="accountName"
              />
              <v-autocomplete
                v-else
                v-model="laverie.accountId"
                :items="accounts"
                item-title="name"
                item-value="id"
                label="Siège"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Laverie & Adresse -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Laverie & Adresse</span>
          <template #actions>
            <v-icon v-if="laverieAndAddressPanelCompleted" color="teal">
              mdi-check
            </v-icon>
          </template>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="laverie.name"
                maxlength="100"
                counter
                :rules="rules.laverieName"
                ><template #label>
                  Nom de la Laverie<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="laverie.numeroDeContrat"
                label="Numéro de contrat"
                type="number"
              />
            </v-col>

            <v-col sm="12" md="4">
              <v-autocomplete
                v-bind:items="laverieTypeContrat"
                hint="Le type du Contrat de la laverie"
                v-model="laverie.typeContrat"
              >
                <template #label>
                  Type du Contrat<span class="text-error"><strong> *</strong></span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row density="compact">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="laverie.dateDeDemarrage"
                label="Date de démarrage *"
                type="date"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="laverie.dateDeRenouvelement"
                label="Date de renouvellement *"
                type="date"
              />
            </v-col>
            <v-col sm="12" md="4">
              <v-text-field
                name="dureeDuContrat"
                hint="La durée du contrat de la laverie"
                type="number"
                suffix="ans"
                v-model="laverie.dureeDuContrat"
              >
                <template #label>
                  Durée du Contrat<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row density="compact">
            <v-col sm="12" md="4">
              <v-text-field
                name="codeTournee"
                label="Code Tournée"
                hint="Le code de la tournée du technicien"
                type="text"
                v-model="laverie.codeTournee"
                
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="4">
              <v-autocomplete
                name="periodicity"
                v-bind:items="laveriePeriodicityStatus"
                label="Periodicité"
                hint="La periodicité de la tournée du technicien"
                v-model="laverie.periodicity"
              />
            </v-col>
            <v-col sm="12" md="4">
              <v-autocomplete
                name="contratStatus"
                v-bind:items="laverieContratStatus"
                label="Statut Du Contrat"
                hint="Le statut du contrat"
                v-model="laverie.contratStatus"
              />
            </v-col>
          </v-row>
          <v-row density="compact">
            <v-col sm="12" md="4">
              <v-text-field
                name="siret"
                label="Siret"
                hint="Le numero siret de la laverie"
                type="text"
                v-model="laverie.siret"
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="4">
              <v-text-field
                :disabled="!isTerminationDateFieldEnabled"
                v-model="laverie.terminationDate"
                label="Date de résiliation"
                type="date"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row density="compact">
            <v-col sm="12" md="6">
              <v-text-field
                v-if="laverie.address"
                name="numero"
                maxlength="15"
                counter="15"
                hint="Le numero dans la rue"
                type="text"
                v-model="laverie.address.numero"
                label="N°"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                v-if="laverie.address"
                name="rue"
                maxlength="50"
                counter="50"
                hint="Le nom de la rue"
                type="text"
                v-model="laverie.address.rue"
                v-bind:rules="rules.addressRue"
              >
                <template #label>
                  Rue<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row density="compact">
            <v-col sm="12" md="6">
              <v-text-field
                v-if="laverie.address"
                name="codepostale"
                maxlength="5"
                counter="5"
                hint="Le code postale de la ville"
                type="text"
                v-model="laverie.address.codepostale"
                v-bind:rules="rules.addressCodePostale"
              >
                <template #label>
                  Code Postale<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                v-if="laverie.address"
                name="ville"
                maxlength="50"
                counter="50"
                hint="Le nom de la ville"
                type="text"
                v-model="laverie.address.ville"
                v-bind:rules="rules.addressVille"
              >
                <template #label>
                  Ville<span class="text-error"><strong>* </strong></span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Contrat & Tarifs -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Contrat & Tarifs</span>
          <template #actions>
            <v-icon v-if="contratAndTarifsPanelCompleted" color="teal">
              mdi-check
            </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.tarifLavage"
                type="number"
                prefix="€"
                hint="Le tarif lavage appliqué"
                label="Tarif Lavage *"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.tarifSechage"
                type="number"
                prefix="€"
                hint="Le tarif séchage appliqué"
                label="Tarif Séchage *"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.tarifLessive"
                type="number"
                prefix="€"
                hint="Le tarif lessive appliqué"
                label="Tarif Lessive *"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.tempsSechage"
                type="number"
                suffix="min"
                hint="Le temps du séchage en minutes"
                label="Temps de Séchage *"
              />
            </v-col>
          </v-row>

          <v-row density="compact">
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="laverie.moyenDePaiement"
                :items="laverieMoyenDePaiements"
                hint="Le moyen de paiement disponible dans la laverie"
                label="Moyen de Paiement *"
              />
            </v-col>
            <v-col
              v-if="
                laverie.typeContrat !== TypeContrat.LOCATION &&
                laverie.typeContrat !== TypeContrat.VENTE
              "
              cols="12"
              md="3"
            >
              <v-text-field
                v-model.number="laverie.tauxDeRedevance"
                type="number"
                suffix="%"
                hint="Le taux de redevance appliqué"
                label="Taux de Redevance *"
              />
            </v-col>
            <v-col
              v-if="
                laverie.typeContrat !== TypeContrat.LOCATION &&
                laverie.typeContrat !== TypeContrat.VENTE
              "
              cols="12"
              md="3"
            >
              <v-text-field
                v-model.number="laverie.seuil"
                type="number"
                prefix="€"
                label="Seuil *"
              />
            </v-col>
          </v-row>

          <v-row density="compact" v-if="laverie.typeContrat === TypeContrat.LOCATION">
            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.locationLaveLinge"
                type="number"
                prefix="€"
                label="Location Lave Linge *"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.locationSecheLinge"
                type="number"
                prefix="€"
                label="Location Sèche Linge *"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.locationMonnayeur"
                type="number"
                prefix="€"
                label="Location Monnayeur *"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.locationArmoirePompeLessive"
                type="number"
                prefix="€"
                label="Location Armoire & Pompe à Lessive *"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="laverie.locationCentralePaiement"
                type="number"
                prefix="€"
                label="Location Centrale de Paiement *"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Contact & Accès -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Contact & Accès</span>
          <template #actions>
            <v-icon v-if="contactAndAccessPanelCompleted" color="teal">
              mdi-check
            </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="laverie.gestionnaire"
                name="gestionnaire"
                label="Gestionnaire"
                hint="Le gestionnaire de la laverie est requis"
                persistent-hint
                type="text"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="laverie.email"
                name="email"
                label="Courriel"
                hint="L'adresse email de la laverie"
                persistent-hint
                type="text"
              />
            </v-col>
          </v-row>

          <v-row density="compact">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="laverie.codeAcces"
                name="codeAcces"
                label="Code D'Accès"
                hint="Le code d'accès à la laverie"
                persistent-hint
                type="text"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="laverie.website"
                name="website"
                label="Website"
                hint="Le website de la laverie"
                persistent-hint
                type="text"
              />
            </v-col>
          </v-row>

          <v-row density="compact">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="laverie.telephonePrincipal"
                name="telephonePrincipal"
                label="Téléphone Principal"
                hint="Le numero de téléphone principal"
                persistent-hint
                :rules="rules.phoneNb"
                type="text"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="laverie.telephoneAutre"
                name="telephoneAutre"
                label="Téléphone Secondaire"
                hint="Le numéro de téléphone secondaire"
                persistent-hint
                :rules="rules.phoneNb"
                type="text"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Nombre de Produits -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Nombre de Produits</span>
          <template v-slot:actions>
            <v-icon v-if="nombreProduitPanelCompleted" color="teal"> mdi-check </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="3">
              <v-text-field
                name="nbSecheLinge"
                hint="Le nombre de sèche linge"
                type="number"
                v-model="laverie.nbSecheLinge"
              >
                <template #label>
                  Nbre Sèche Linge<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbLaveLingeChauffant"
                hint="Le nombre de lave linge chauffant"
                type="number"
                v-model="laverie.nbLaveLingeChauffant"
              >
                <template #label>
                  Nbre Lave Linge Chauffant<span class="text-error"
                    ><strong> *</strong></span
                  >
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbLaveLinge"
                hint="Le nombre de lave linge"
                type="number"
                v-model="laverie.nbLaveLinge"
              >
                <template #label>
                  Nbre Lave Linge<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbLintTrap"
                hint="Le nombre de lint trap"
                type="number"
                v-model="laverie.nbLintTrap"
              >
                <template #label>
                  Nbre Lint Trap<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row density="compact">
            <v-col cols="12" md="3">
              <v-text-field
                name="nbCondensateur"
                hint="Le nombre de condensateur"
                type="number"
                v-model="laverie.nbCondensateur"
              >
                <template #label>
                  Nbre Condensateur<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbArmoireLessive"
                hint="Le nombre d'armoire à lessive"
                type="number"
                v-model="laverie.nbArmoireLessive"
              >
                <template #label>
                  Nbre Armoire à Lessive<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbPompeLessive"
                hint="Le nombre de pompe à lessive"
                type="number"
                v-model="laverie.nbPompeLessive"
              >
                <template #label>
                  Nbre Pompe à Lessive<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbStackedLave"
                hint="Le nombre de Stacked Lave"
                type="number"
                v-model="laverie.nbStackedLave"
              >
                <template #label>
                  Nbre Stacked Lave<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row density="compact">
            <v-col cols="12" md="3">
              <v-text-field
                name="nbStackedSeche"
                hint="Le nombre de Stacked Seche"
                type="number"
                v-model="laverie.nbStackedSeche"
              >
                <template #label>
                  Nbre Stacked Seche<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbCentrale"
                hint="Le nombre de Centrale"
                type="number"
                v-model="laverie.nbCentrale"
              >
                <template #label>
                  Nbre Centrale<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbMonnayeur"
                hint="Le nombre de Monnayeur"
                type="number"
                v-model="laverie.nbMonnayeur"
              >
                <template #label>
                  Nbre Monnayeur<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                name="nbBallonEauChaude"
                hint="Le nombre de Ballon d'eau chaude"
                type="number"
                v-model="laverie.nbBallonEauChaude"
              >
                <template #label>
                  Nbre Ballon Eau Chaude<span class="text-error"><strong> *</strong></span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Produits -->
      <v-expansion-panel v-if="!isCreatingNewLaverie">
        <v-expansion-panel-title>
          <span class="text-primary">Produits</span>
          <template v-slot:actions>
            <v-icon v-if="productsCount > 0" color="teal"> mdi-check </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row v-if="productsCount > 0" density="compact">
            <v-col cols="12">
              <v-list class="bg-transparent elevation-0" lines="two">
                <v-list-item
                  v-for="(p, index) in productsByLaverie"
                  :key="index"
                  class="bg-grey-lighten-2 my-2"
                >
                  <v-list-item-title class="text-teal font-weight-medium">
                    {{ p.productType }} | {{ p.productMake }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="text-grey-darken-4">
                    N° aqua: {{ p.aquaNb }} | N° série: {{ p.serialNb }} | Compteur:
                    {{ p.compteur }} | Modèle:
                    {{ p.model }} | {{ p.productStatus }}
                  </v-list-item-subtitle>

                  <v-list-item-subtitle>
                    {{ p.reservationStatus }} | Date bon d'entrée: {{ p.bonEntreeDate }} |
                    N° bon d'entrée:
                    {{ p.bonEntreeNb }}
                  </v-list-item-subtitle>

                  <template #append>
                    <v-tooltip location="start">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          color="teal"
                          elevation="4"
                          class="ma-1"
                          :to="`/products/${p.id}`"
                        >
                          <v-icon color="white">mdi-application-import</v-icon>
                        </v-btn>
                      </template>
                      <span>Aller au produit</span>
                    </v-tooltip>

                    <v-tooltip location="start">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          color="teal"
                          elevation="4"
                          class="ma-1"
                          @click="removeProduct(p)"
                        >
                          <v-icon color="white">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Supprimer le produit</span>
                    </v-tooltip>
                  </template>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Historique des produits -->
      <v-expansion-panel v-if="!isCreatingNewLaverie">
        <v-expansion-panel-title>
          <span class="text-primary">Historique des produits</span>
          <template v-slot:actions>
            <v-icon v-if="productsHistoryCount > 0" color="teal"> mdi-check </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row v-if="productsHistoryCount > 0" density="compact">
            <v-col cols="12">
              <v-list class="bg-transparent elevation-0" lines="two">
                <v-list-item
                  v-for="(historyElement, index) in productsHistory"
                  :key="index"
                  class="bg-grey-lighten-2 my-2"
                >
                  <v-list-item-title class="text-teal font-weight-medium">
                    {{ historyElement.productType }} | 
                    {{ historyElement.productMake }}
                  </v-list-item-title>

                   <v-list-item-subtitle class="text-grey-darken-4">
                   N° aqua:
                   {{ historyElement.productAquaNb }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-grey-darken-4">
                    Entrée:
                    {{
                      historyElement.inDate
                        ? formattedDate(historyElement.inDate)
                        : "Inconnue"
                    }}
                  </v-list-item-subtitle>

                  <v-list-item-subtitle>
                    Sortie:
                    {{
                      historyElement.outDate
                        ? formattedDate(historyElement.outDate)
                        : "Inconnue"
                    }}
                  </v-list-item-subtitle>

                  <template #append>
                    <v-tooltip v-if="historyElement.productId" location="start">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          color="teal"
                          elevation="4"
                          class="ma-1"
                          :to="`/products/${historyElement.productId}`"
                        >
                          <v-icon color="white">mdi-application-import</v-icon>
                        </v-btn>
                      </template>
                      <span>Aller au produit</span>
                    </v-tooltip>
                  </template>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Avenants -->
      <v-expansion-panel v-if="!isCreatingNewLaverie">
        <v-expansion-panel-title>
          <span class="text-primary">Avenants</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12">
              <v-list class="bg-transparent elevation-0" lines="two">
                <v-list-item
                  v-for="(avenant, index) in avenantsByLaverie"
                  :key="index"
                  class="bg-grey-lighten-2 my-2"
                >
                  <v-list-item-title class="text-primary font-weight-medium">
                    Avenant du {{ formattedDate(avenant.dateDeDemarrage) }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="text-grey-darken-4">
                    Durée: {{ avenant.dureeDuContrat }} ans
                  </v-list-item-subtitle>

                  <v-list-item-subtitle>
                    Observation: {{ avenant.observation }}
                  </v-list-item-subtitle>

                  <template #append>
                    <v-btn
                      icon
                      size="small"
                      color="teal"
                      elevation="4"
                      class="mr-2"
                      @click="editAvenant(avenant)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      icon
                      size="small"
                      color="cyan"
                      elevation="4"
                      @click.stop="removeAvenant(avenant)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Vie du contrat -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Vie du contrat</span>
          <template v-slot:actions>
            <v-icon v-if="vieDuContratPanelCompleted" color="teal"> mdi-check </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-list-item>
            <v-list-item-title class="font-weight-black mb-2">
              Première Prise de Contact
            </v-list-item-title>

            <v-row density="compact">
              <v-col cols="12" md="6">
                <v-select
                  :items="priseDeContactTypes"
                  label="Comment"
                  v-model="laverie.priseDeContactType"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="laverie.priseDeContactDate" label="Quand" type="date" />
              </v-col>
            </v-row>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="font-weight-black mb-2">
              Prévisite
            </v-list-item-title>

            <v-row density="compact">
              <v-col cols="12" md="6">
                <v-text-field label="Qui" v-model="laverie.previsiteBy" />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="laverie.previsiteDate" label="Quand" type="date" />
              </v-col>

              <v-col cols="12">
                <v-textarea label="Observation" v-model="laverie.previsitText" />
              </v-col>

              <v-col cols="10">
                <v-file-input
                  v-model="currentSelectedPrevisiteFile"
                  label="Bon de prévisite (Max 2MB)"
                  show-size
                />
              </v-col>

              <v-col cols="2" class="pt-6">
                <v-btn
                  color="success"
                  size="small"
                  :disabled="isDisabledPrevisiteFileUploadBtn"
                  @click="upload"
                >
                  Upload
                  <v-icon end>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12" v-if="showProgressBar">
                <span>{{ progressInfo.fileName }}</span>
                <v-progress-linear :model-value="progressInfo.percentage" height="25">
                  <strong>{{ progressInfo.percentage }} %</strong>
                </v-progress-linear>
              </v-col>

              <v-col cols="12">
                <v-alert
                  v-if="previsitFileMessage"
                  type="success"
                  variant="outlined"
                  closable
                >
                  {{ previsitFileMessage }}
                </v-alert>

                <v-list-item v-if="previsiteFileInfo.url">
                  <v-list-item-title>
                    <div class="file-link-row">
                      <a
                        href="#"
                        class="file-link"
                        @click.prevent="downloadPrevisiteAuthenticated(previsiteFileInfo)"
                      >
                        {{ previsiteFileInfo.name }}
                      </a>
                      <v-btn
                        icon
                        size="x-small"
                        variant="text"
                        @click.stop="downloadPrevisiteAuthenticated(previsiteFileInfo)"
                        title="Download"
                      >
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="font-weight-black mb-2">
              Signature du Contrat
            </v-list-item-title>

            <v-row density="compact">
              <v-col cols="12" md="6">
                <v-text-field v-model="laverie.dateSignatureContrat" label="Date" type="date" />
              </v-col>
            </v-row>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="font-weight-black mb-2">
              Vérification des Travaux
            </v-list-item-title>

            <v-row density="compact">
              <v-col cols="12">
                <v-textarea label="Observation" v-model="laverie.verifTravaux" />
              </v-col>
            </v-row>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="font-weight-black mb-2">
              Installation
            </v-list-item-title>

            <v-row density="compact">
              <v-col cols="12" md="6">
                <v-text-field label="Qui" v-model="laverie.installateur" />
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field v-model="laverie.installationDate" label="Quand" type="date" />
              </v-col>

              <v-col cols="10">
                <v-file-input
                  v-model="currentSelectedBonInstallFile"
                  label="Bon d'installation (Max 2MB)"
                  show-size
                />
              </v-col>

              <v-col cols="2" class="pt-6">
                <v-btn
                  color="success"
                  size="small"
                  :disabled="isDisabledUploadBonInstallBtn"
                  @click="uploadBonInstall"
                >
                  Upload
                  <v-icon end>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12" v-if="showBonInstallProgressBar">
                <span>{{ bonInstallProgressInfo.fileName }}</span>
                <v-progress-linear
                  :model-value="bonInstallProgressInfo.percentage"
                  height="25"
                >
                  <strong>{{ bonInstallProgressInfo.percentage }} %</strong>
                </v-progress-linear>
              </v-col>

              <v-col cols="12">
                <v-alert
                  v-if="bonInstallMessage"
                  type="success"
                  variant="outlined"
                  closable
                >
                  {{ bonInstallMessage }}
                </v-alert>

                <v-list-item v-if="bonInstallFileInfo.url">
                  <v-list-item-title>
                    <div class="file-link-row">
                      <a
                        href="#"
                        class="file-link"
                        @click.prevent="downloadBonInstallAuthenticated(bonInstallFileInfo)"
                      >
                        {{ bonInstallFileInfo.name }}
                      </a>
                      <v-btn
                        icon
                        size="x-small"
                        variant="text"
                        @click.stop="downloadBonInstallAuthenticated(bonInstallFileInfo)"
                        title="Download"
                      >
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
               <v-col cols="12" md="6">
                <v-text-field v-model="laverie.collectionDate" label="Date d'enlèvement" type="date" />
              </v-col>
            </v-row>
          </v-list-item>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Information techniques -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Informations Techniques</span>
          <template v-slot:actions>
            <v-icon v-if="informationTechniquePanelCompleted" color="teal">
              mdi-check
            </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12" md="2">
              <v-text-field label="Type prise LL" v-model="laverie.typePriseLL" />
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field label="Type prise SL" v-model="laverie.typePriseSL" />
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field label="Clé caisse" v-model="laverie.cleCaisse" />
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Clé de programmation"
                v-model="laverie.cleDeProgrammation"
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-autocomplete
                :items="laverieJetonLLTypes"
                label="Jetons LL"
                v-model="laverie.jetonLLType"
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-autocomplete
                :items="laverieJetonSLTypes"
                label="Jetons SL"
                v-model="laverie.jetonSLType"
              />
            </v-col>
          </v-row>

          <v-row density="compact">
            <v-col cols="12">
              <v-textarea label="Observation" v-model="laverie.observationTechnique" />
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Fiche de preparation -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Fiche de Préparation</span>
          <template v-slot:actions>
            <v-icon v-if="false" color="teal"> mdi-check </v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <FichePreparationContent :laverie="laverie" :users="users">
          </FichePreparationContent>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Documents Disponibles -->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-primary">Documents Disponibles</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="file-list-container">
            <!-- Prévisite File -->
            <v-list-item
              v-if="previsiteFileInfo?.url"
              class="file-list-item"
              :prepend-icon="getFileIcon(previsiteFileInfo.name)"
              @click="downloadPrevisiteAuthenticated(previsiteFileInfo)"
            >
              <template #title>
                <div class="file-item-content">
                  <span class="file-label">Prévisite file:</span>
                  <a
                    class="file-link"
                    @click.stop="downloadPrevisiteAuthenticated(previsiteFileInfo)"
                    :title="`Download ${previsiteFileInfo.name}`"
                  >
                    {{ previsiteFileInfo.name }}
                  </a>
                </div>
              </template>
              <template #append>
                <v-btn
                  icon
                  size="small"
                  variant="text"
                  @click.stop="downloadPrevisiteAuthenticated(previsiteFileInfo)"
                  title="Download"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-btn
                  icon
                  size="small"
                  variant="text"
                  @click="previewFile(previsiteFileInfo)"
                  title="Preview"
                  v-if="isPreviewable(previsiteFileInfo.name)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-list-item>

            <!-- Bon d'installation File -->
            <v-list-item
              v-if="bonInstallFileInfo?.url"
              class="file-list-item"
              :prepend-icon="getFileIcon(bonInstallFileInfo.name)"
              @click="downloadBonInstallAuthenticated(bonInstallFileInfo)"
            >
              <template #title>
                <div class="file-item-content">
                  <span class="file-label">Bon d'installation:</span>
                  <a
                    class="file-link"
                    @click.stop="downloadBonInstallAuthenticated(bonInstallFileInfo)"
                    :title="`Download ${bonInstallFileInfo.name}`"
                  >
                    {{ bonInstallFileInfo.name }}
                  </a>
                </div>
              </template>
              <template #append>
                <div class="file-actions">
                  <v-btn
                    icon
                    size="small"
                    variant="text"
                    @click.stop="downloadBonInstallAuthenticated(bonInstallFileInfo)"
                    title="Download"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-list-item>

            <!-- Empty State -->
            <div
              v-if="!previsiteFileInfo?.url && !bonInstallFileInfo?.url"
              class="no-files"
            >
              <v-icon size="large" class="mb-2">mdi-folder-open-outline</v-icon>
              <p class="text-medium-emphasis">No files uploaded yet</p>
            </div>
          </div>

          <v-dialog :scrim="true" v-model="previewDialog" max-width="800">
            <v-card>
              <v-card-title>
                <span>Preview: {{ previewFileInfo?.name }}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="previewDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <iframe
                  v-if="previewFileInfo?.url && isPdf(previewFileInfo.name)"
                  :src="previewFileInfo.url"
                  width="100%"
                  height="500"
                  class="preview-frame"
                ></iframe>
                <div v-else class="unsupported-preview">
                  <v-icon size="64" class="mb-4">mdi-file</v-icon>
                  <p>Preview not available for this file type</p>
                  <v-btn :href="previewFileInfo?.url" download color="primary">
                    Download File
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Tournées Techniciens -->
      <v-expansion-panel v-if="String(showTaskListPanel) === 'true'">
        <v-expansion-panel-title>
          <span class="text-primary">Tournées Techniciens</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-list>
            <v-list-item
              v-for="(taskList, index) in taskListsHistory"
              :key="index"
              class="bg-grey-lighten-4 mt-2 mb-2"
              rounded="lg"
            >
              <template #title>
                <div class="d-flex align-center">
                  <span class="heading text-blue-darken-2 font-weight-bold">
                    {{ taskList.codeTournee }}
                  </span>
                  <v-divider vertical class="mx-3" />
                  <span>{{ formattedDate(taskList.dateDebut) }}</span>
                  <v-divider vertical class="mx-3" />
                  <span>Statut: {{ getStatusText(taskList.taskListStatus) }}</span>
                </div>
              </template>
            </v-list-item>
          </v-list>
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Notifications -->
      <v-expansion-panel>
        <v-expansion-panel-title v-slot="{ expanded }">
          <v-row density="compact">
            <v-col cols="4" class="text-primary"> Notifications </v-col>

            <v-col cols="8" class="text-secondary">
              <VFadeTransition leave-absolute>
                <span v-if="expanded" />
                <span v-else>
                  <div v-if="laverie">
                    {{ notificationPanelText }}
                  </div>
                </span>
              </VFadeTransition>
            </v-col>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row density="compact">
            <v-col cols="12">
              <v-switch
                v-model="laverie.notificationEnabled"
                label="Activer les notifications (Recevoir une alerte dans le dashboard à 90 jours de l'expiration du contrat)"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <ConfirmDialog
      v-model="removeProductDialog"
      :dialogTitle="removeProductDialogTitle"
      :dialogText="removeProductDialogText"
      @confirm="confirmRemoveProduct"
      @cancel="cancelRemoveProduct"
      confirm-button-text="Confirmer"
      cancel-button-text="Annuler"
    ></ConfirmDialog>
    <ConfirmDialog
      v-model="removeAvenantDialog"
      :dialogTitle="removeAvenantDialogTitle"
      :dialogText="removeAvenantDialogText"
      @confirm="confirmRemoveAvenant"
      @cancel="cancelRemoveAvenant"
      confirm-button-text="Confirmer"
      cancel-button-text="Annuler"
    ></ConfirmDialog>
  </v-container>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import { Account, getLaverieGen } from "@/types";
import { Avenant } from "@/types";
import {
  ContratStatus,
  JetonLLType,
  JetonSLType,
  MoyenDePaiement,
  PeriodiciteStatus,
  PriseDeContactType,
  TaskListStatus,
  TypeContrat,
} from "@/types";
import { Laverie } from "@/types";
import { Product } from "@/types";
import { deleteAvenant, getAvenantsByLaverie } from "@/utils/avenant-api";
import {
  getLaverieById,
  postLaverie,
  putLaverie,
  removeProductFromLaverie,
} from "@/utils/laverie-api";
import { getProductsByLaverieId } from "@/utils/product-api";
import {
  isNotEmpty,
  isValidCodePostale,
  isValidEmail,
  isValidPhoneNumber,
} from "@/utils/validation-util";
import { ref, computed, onBeforeMount } from "vue";
import { onMounted } from "vue";
import { getAccountById, getAllAccounts } from "@/utils/account-api";
import { getAllUsers } from "@/utils/user-api";
import { User } from "@/types";
import { getTaskListsHistory } from "@/utils/tasklist-api";
import { TaskList } from "@/types";
import {
  downloadPrevisiteFile,
  downloadBonInstallFile,
  getBonInstallFileInfo,
  getPrevisiteFileInfo,
  uploadBonInstallFile,
  uploadPrevisiteFile,
} from "@/utils/files-service";
import { Address } from "@/types";
import { FileInfo } from "@/types";
import { ProgressInfo } from "@/types";
import { createAndSaveDocument } from "@/utils/docx-util";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import FichePreparationContent from "@/components/FichePreparationContent.vue";
import { AxiosProgressEvent } from "axios";
import { LaundryProductHistoryElement } from "@/types/laundry-product-history-element";
import { fetchHistoryElementsByLaundry } from "@/utils/laverie-product-history-element-api";

interface Props {
  accountName?: string;
  accountId?: string;
  showTaskListPanel?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showTaskListPanel: true,
});

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();

const loading = ref(false);
const title = ref("Laverie");

const accounts = ref<Account[]>([]);
const users = ref<User[]>([]);
const accountName = ref<string | null>(null);

const laverie = ref<Laverie>({} as Laverie);
const removeProductDialog = ref(false);
const removeAvenantDialog = ref(false);
const removeProductDialogTitle = "Suppression du produit";
const removeProductDialogText = "Vouez-vous supprimer ce produit?";
const removeAvenantDialogTitle = "Suppression de l'avenant";
const removeAvenantDialogText = "Vouez-vous supprimer cet avenant?";
const selectedProductToRemove = ref<Product | null>(null);
const selectedAvenantToRemove = ref<Avenant | null>(null);
const productsByLaverie = ref<Product[]>([]);
const avenantsByLaverie = ref<Avenant[]>([]);
const taskListsHistory = ref<TaskList[]>([]);
const productsHistory = ref<LaundryProductHistoryElement[]>([]);
const previsiteFileInfo = ref<FileInfo | null>(null);
const bonInstallFileInfo = ref<FileInfo | null>(null);
const currentSelectedPrevisiteFile = ref<File | null>(null);
const currentSelectedBonInstallFile = ref<File | null>(null);
const previsitFileMessage = ref("");
const bonInstallMessage = ref("");
const showProgressBar = ref(false);
const showBonInstallProgressBar = ref(false);
const progressInfo = ref<ProgressInfo>({ percentage: 0, fileName: "" });
const bonInstallProgressInfo = ref<ProgressInfo>({ percentage: 0, fileName: "" });
const previewDialog = ref(false);
const previewFileInfo = ref<FileInfo | null>(null);

const isCreatingNewLaverie = computed(
  () =>
    "newlaverie" === route.name ||
    "newlaverieforaccount" === route.name ||
    "newlaverie" === route.params.id
);

const siegePanelCompleted = computed(() => !!laverie.value.accountId);
const laverieAndAddressPanelCompleted = computed(
  () => !!laverie.value.name && !!laverie.value.dateDeDemarrage
);

const isTerminationDateFieldEnabled = computed(() => {
  return laverie.value.contratStatus === ContratStatus.RESILIER;
});

const laverieTypeContrat = computed(() => Object.values(TypeContrat));
const laverieContratStatus = computed(() => Object.values(ContratStatus));
const laveriePeriodicityStatus = computed(() => Object.values(PeriodiciteStatus));
const laverieMoyenDePaiements = computed(() => Object.values(MoyenDePaiement));
const priseDeContactTypes = computed(() => Object.values(PriseDeContactType));
const laverieJetonLLTypes = computed(() => Object.values(JetonLLType));
const laverieJetonSLTypes = computed(() => Object.values(JetonSLType));
const contratAndTarifsPanelCompleted = computed(() => {
  if (laverie.value.typeContrat == TypeContrat.VENTE) {
    return (
      laverie.value.tarifLavage &&
      laverie.value.tarifSechage &&
      laverie.value.tarifLessive &&
      laverie.value.tempsSechage &&
      laverie.value.moyenDePaiement
    );
  }
  if (laverie.value.typeContrat == TypeContrat.LOCATION) {
    return (
      laverie.value.tarifLavage &&
      laverie.value.tarifSechage &&
      laverie.value.tarifLessive &&
      laverie.value.tempsSechage &&
      laverie.value.moyenDePaiement &&
      laverie.value.locationLaveLinge &&
      laverie.value.locationSecheLinge &&
      laverie.value.locationMonnayeur &&
      laverie.value.locationArmoirePompeLessive &&
      laverie.value.locationCentralePaiement
    );
  }
  return (
    laverie.value.tarifLavage &&
    laverie.value.tarifSechage &&
    laverie.value.tarifLessive &&
    laverie.value.tempsSechage &&
    laverie.value.moyenDePaiement &&
    laverie.value.tauxDeRedevance &&
    laverie.value.seuil
  );
});

const contactAndAccessPanelCompleted = computed(() => {
  return laverie.value.gestionnaire && laverie.value.telephonePrincipal;
});

const nombreProduitPanelCompleted = computed(() => {
  return (
    laverie.value.nbSecheLinge &&
    laverie.value.nbLaveLingeChauffant &&
    laverie.value.nbLaveLinge &&
    laverie.value.nbLintTrap &&
    laverie.value.nbCondensateur &&
    laverie.value.nbPompeLessive &&
    laverie.value.nbArmoireLessive &&
    laverie.value.nbStackedLave &&
    laverie.value.nbStackedSeche &&
    laverie.value.nbCentrale &&
    laverie.value.nbMonnayeur &&
    laverie.value.nbBallonEauChaude
  );
});

const productsCount = computed(() => {
  return productsByLaverie.value?.length ?? 0;
});

const productsHistoryCount = computed(() => {
  return productsHistory.value?.length ?? 0;
});

const vieDuContratPanelCompleted = computed(() => {
  return (
    laverie.value.previsiteBy &&
    laverie.value.previsiteDate &&
    laverie.value.dateSignatureContrat &&
    laverie.value.installateur
  );
});

const informationTechniquePanelCompleted = computed(() => {
  return (
    laverie.value.typePriseLL &&
    laverie.value.typePriseSL &&
    laverie.value.cleCaisse &&
    laverie.value.cleDeProgrammation &&
    laverie.value.jetonLLType &&
    laverie.value.jetonSLType
  );
});

const notificationPanelText = computed(() => {
  if (laverie.value) {
    if (laverie.value.notificationEnabled) {
      return "Activer";
    }
    return "Désactiver";
  }
  return "";
});

const isDisabledPrevisiteFileUploadBtn = computed(() => {
  return !(currentSelectedPrevisiteFile.value && laverie.value.id);
});

const isDisabledUploadBonInstallBtn = computed(() => {
  return !(currentSelectedBonInstallFile.value && laverie.value.id);
});

const rules = computed(() => ({
  phoneNb: [() => isValidPhoneNumber(laverie?.value.telephonePrincipal ?? "")],
  email: [() => isValidEmail(laverie?.value.email ?? "")],
  laverieName: [() => isNotEmpty(laverie?.value.name ?? "")],
  addressRue: [() => isNotEmpty(laverie?.value.address?.rue ?? "")],
  addressVille: [() => isNotEmpty(laverie?.value.address?.ville ?? "")],
  addressCodePostale: [
    () => isValidCodePostale(laverie?.value.address?.codepostale ?? ""),
  ],
}));

function isPdf(fileName: string): boolean {
  return fileName.toLowerCase().endsWith(".pdf");
}

function getStatusText(status: TaskListStatus): string {
  const statusMap: Record<string, string> = {
    A_FAIRE: "A FAIRE",
    ASSIGNE: "ASSIGNE",
    EN_COURS: "EN COURS",
    FAITE: "FAITE",
    APPROUVE: "APPROUVE",
  };

  return statusMap[status] || status;
}

function downloadFile(fileInfo: FileInfo): void {
  if (!fileInfo?.url) return;
  const link = document.createElement("a");
  link.href = fileInfo.url;
  link.download = fileInfo.name;
  link.click();
}

function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}

async function downloadBonInstallAuthenticated(fileInfo: FileInfo): Promise<void> {
  if (!laverie.value?.id) {
    appStore.sendErrorNotice("Laverie ID is missing");
    return;
  }

  try {
    const response = await downloadBonInstallFile(laverie.value.id);
    downloadBlob(response.data, fileInfo.name);
  } catch (error) {
    appStore.sendErrorNotice("Could not download Bon d'installation file");
    console.error("Bon Install download failed:", error);
  }
}

async function downloadPrevisiteAuthenticated(fileInfo: FileInfo): Promise<void> {
  if (!laverie.value?.id) {
    appStore.sendErrorNotice("Laverie ID is missing");
    return;
  }

  try {
    const response = await downloadPrevisiteFile(laverie.value.id);
    downloadBlob(response.data, fileInfo.name);
  } catch (error) {
    appStore.sendErrorNotice("Could not download Prévisite file");
    console.error("Prévisite download failed:", error);
  }
}

function getFileIcon(fileName: string): string {
  const extension = fileName.split(".").pop()?.toLowerCase();

  const iconMap: Record<string, string> = {
    pdf: "mdi-file-pdf-box",
    doc: "mdi-file-word-box",
    docx: "mdi-file-word-box",
    xls: "mdi-file-excel-box",
    xlsx: "mdi-file-excel-box",
    txt: "mdi-file-document-outline",
    zip: "mdi-folder-zip-outline",
    exe: "mdi-application",
    png: "mdi-file-image",
    jpg: "mdi-file-image",
    jpeg: "mdi-file-image",
    gif: "mdi-file-image",
  };

  return iconMap[extension || ""] || "mdi-file";
}

function isPreviewable(fileName: string): boolean {
  const previewableExtensions = ["pdf", "png", "jpg", "jpeg", "gif", "txt"];
  const extension = fileName.split(".").pop()?.toLowerCase();
  return previewableExtensions.includes(extension || "");
}

function previewFile(fileInfo: FileInfo): void {
  if (!fileInfo?.url || !isPreviewable(fileInfo.name)) return;

  previewFileInfo.value = fileInfo;
  previewDialog.value = true;
}

type UploadResponseData = {
  success?: boolean;
  message?: string;
  status?: string;
};

function isUploadSuccessful(responseData?: UploadResponseData): boolean {
  return (
    responseData?.success === true ||
    responseData?.status === "SUCCESS" ||
    responseData?.status === "OK" ||
    (typeof responseData?.message === "string" &&
      responseData.message.toLowerCase().includes("success"))
  );
}

function getUploadErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return "Unknown error";
}

function selectBonInstallFile(file) {
  bonInstallProgressInfo.value.percentage = 0;
  currentSelectedBonInstallFile.value = file;
}

async function uploadBonInstall(): Promise<void> {
  // Validate inputs
  if (!currentSelectedBonInstallFile.value) {
    bonInstallMessage.value = "Please select a Bon Install file first";
    return;
  }

  if (!laverie.value?.id) {
    bonInstallMessage.value = "Laverie ID is missing";
    return;
  }

  // Reset and set up progress
  showBonInstallProgressBar.value = true;
  bonInstallProgressInfo.value.percentage = 0;
  bonInstallProgressInfo.value.fileName = currentSelectedBonInstallFile.value.name;
  bonInstallMessage.value = "";

  try {
    // Upload file with progress tracking
    const response = await uploadBonInstallFile(
      currentSelectedBonInstallFile.value,
      laverie.value.id,
      (event: ProgressEvent) => {
        if (event.lengthComputable) {
          bonInstallProgressInfo.value.percentage = Math.round(
            (100 * event.loaded) / event.total
          );
        }
      }
    );

    // Handle successful upload
    showBonInstallProgressBar.value = false;

    const responseData = response.data as UploadResponseData;
    if (!isUploadSuccessful(responseData)) {
      throw new Error(responseData?.message || "Bon Install upload failed");
    }

    bonInstallMessage.value =
      responseData?.message || "Bon Install file uploaded successfully";

    // Fetch updated file information
    const fileResponse = await getBonInstallFileInfo(laverie.value.id);
    bonInstallFileInfo.value = fileResponse.data;
  } catch (error: unknown) {
    // Handle errors
    showBonInstallProgressBar.value = false;
    bonInstallProgressInfo.value.percentage = 0;

    const fileName = currentSelectedBonInstallFile.value?.name || "unknown file";
    bonInstallMessage.value = `Could not upload the Bon Install file "${fileName}": ${
      getUploadErrorMessage(error)
    }`;

    console.error("Bon Install upload failed:", error);
  }
}
async function upload(): Promise<void> {
  if (!currentSelectedPrevisiteFile.value || !laverie.value.id) {
    appStore.sendErrorNotice("No file selected or laverie ID missing");
    return;
  }

  showProgressBar.value = true;
  progressInfo.value.percentage = 0;
  progressInfo.value.fileName = currentSelectedPrevisiteFile.value.name;

  try {
    const response = await uploadPrevisiteFile(
      currentSelectedPrevisiteFile.value,
      laverie.value.id,
      (event: AxiosProgressEvent) => {
        if (event.progress !== undefined) {
          progressInfo.value.percentage = Math.round(event.progress * 100);
        }
      }
    );

    showProgressBar.value = false;

    const responseData = response.data as UploadResponseData;
    if (!isUploadSuccessful(responseData)) {
      throw new Error(responseData?.message || "Previsite upload failed");
    }

    previsitFileMessage.value =
      responseData?.message || "Previsite file uploaded successfully";

    const file = await getPrevisiteFileInfo(laverie.value.id);
    previsiteFileInfo.value = file.data;
  } catch (error: unknown) {
    showProgressBar.value = false;
    progressInfo.value.percentage = 0;
    previsitFileMessage.value = `Could not upload the Previsite file "${
      currentSelectedPrevisiteFile.value?.name || "unknown file"
    }": ${getUploadErrorMessage(error)}`;
    console.error("Upload failed:", error);
  }
}

function formattedDate(date?: Date) {
  if (!date) return "";
  return new Date(date).toLocaleDateString("fr-FR");
}

function removeProduct(product) {
  selectedProductToRemove.value = product;
  removeProductDialog.value = true;
}

function editAvenant(item: Avenant) {
  router.push({
    name: "avenant",
    params: { laverieId: laverie.value.id, id: item.id },
  });
}

function removeAvenant(item: Avenant) {
  selectedAvenantToRemove.value = item;
  removeAvenantDialog.value = true;
}

async function confirmRemoveProduct() {
  removeProductDialog.value = false;

  try {
    await removeProductFromLaverie(laverie.value.id, selectedProductToRemove.value!.id);
    await initializeProductsByLaverie(laverie.value.id);
    appStore.sendSuccessNotice("Product has been removed from Laverie.");
  } finally {
    selectedProductToRemove.value = null;
  }
}

function cancelRemoveProduct() {
  selectedProductToRemove.value = null;
  removeProductDialog.value = false;
}

async function confirmRemoveAvenant() {
  removeAvenantDialog.value = false;
  try {
    await deleteAvenant(selectedAvenantToRemove.value.id);
    await initializeAvenantsByLaverie(laverie.value.id);
    appStore.sendSuccessNotice("Avenant has been removed from Laverie.");
  } catch (error) {
    console.error(error);
    appStore.sendErrorNotice("Operation failed! Please try again later.");
    throw error;
  } finally {
    selectedAvenantToRemove.value = null;
  }
}

function cancelRemoveAvenant() {
  selectedAvenantToRemove.value = null;
  removeAvenantDialog.value = false;
}

async function initializeProductsByLaverie(laverieId: string) {
  productsByLaverie.value = await getProductsByLaverieId(laverieId);
}

async function initializeTaskListsHistory(laverieId: string) {
  const fetchedTaskLists = await getTaskListsHistory(laverieId);
  taskListsHistory.value = fetchedTaskLists.sort((a, b) =>
    a.dateDebut < b.dateDebut ? 1 : -1
  );
}

async function initializeAvenantsByLaverie(laverieId: string) {
  const fetchedAvenants = await getAvenantsByLaverie(laverieId);
  avenantsByLaverie.value = fetchedAvenants.sort((a, b) =>
    a.dateDeDemarrage < b.dateDeDemarrage ? 1 : -1
  );
}

async function initializeProductsHistoryByLaverie(laverieId: string) {
  const fetchedHistoryElements = await fetchHistoryElementsByLaundry(laverieId);
  productsHistory.value = fetchedHistoryElements.sort((a, b) =>
    a?.inDate < b?.inDate ? 1 : -1
   );
}

function cancel() {
  if ("newlaverieforaccount" === route.name) {
    router.push({
      name: "account",
      params: { id: route.params.accountId },
    });
    return;
  }

  router.push({ name: "laveries" });
}

function contratFileName(): string {
  return "AQUALYS_CONTRAT_".concat(laverie.value.typeContrat);
}

function contratTemplatePath(): string {
  if (laverie.value.typeContrat == TypeContrat.LOCATION) {
    return "../templates/ContratLocationTemplate.docx";
  }
  return "../templates/ContratMonnaieTemplate.docx";
}

async function download() {
  if (laverie.value.accountId) {
    const account = await getAccountById(laverie.value.accountId);
    createAndSaveDocument(
      contratFileName(),
      contratTemplatePath(),
      getLaverieGen(account, laverie.value)
    );
  }
}

function print() {
  window.print();
}

async function save() {
  try {
    loading.value = true;
    const theLaverie = { ...laverie.value };
    if (!laverie.value.id) {
      laverie.value = await postLaverie(theLaverie);
      appStore.sendSuccessNotice("New Laverie has been added.");
      router.replace({
        name: "laverie",
        params: { id: laverie.value.id },
      });
    } else {
      await putLaverie(theLaverie);
      // Refetch the laverie as some filed may be changed by the server after update
      // (i.e. codeTournee will be reset in case of terminated contract)
      laverie.value = await getLaverieById(laverie.value.id);
      appStore.sendSuccessNotice("Laverie has been updated.");
    }
  } catch (error) {
    //  Ignore error as it is handled by the global error handler
  } finally {
    loading.value = false;
  }
}

function createNewAvenant() {
  if (route.params.id) {
    router.push({
      name: "newavenant",
      params: { laverieId: route.params.id },
    });
  }
}

async function initializeAccounts() {
  const fetchedAccounts = await getAllAccounts();
  accounts.value = fetchedAccounts.sort((a, b) => (a.name < b.name ? -1 : 1));
}

async function initializeUsers() {
  const fetchedUsers = await getAllUsers();
  // Create Autre user
  const autreUser = {} as User;
  autreUser.firstname = "Autre";
  autreUser.lastname = "personne";
  autreUser.fullName = "Autre personne";
  // Add it to the users
  fetchedUsers.push(autreUser);
  users.value = fetchedUsers;
}

function getLaverieId(): string | undefined {
  // Return the id when the route path contains laveries, otherwise pass undefined
  return route.path.includes("laveries") ? (route.params.id as string) : undefined;
}

function initEmptyLaverie() {
  laverie.value.notificationEnabled = true;
  laverie.value.address = {} as Address;
}

onMounted(async () => {
  try {
    loading.value = true;
    initializeAccounts();
    initializeUsers();

    const laverieId = getLaverieId();
    if (laverieId) {
      title.value = "Editer la laverie";
      laverie.value = await getLaverieById(laverieId);
      initializeProductsByLaverie(laverieId);
      initializeTaskListsHistory(laverieId);
      initializeAvenantsByLaverie(laverieId);
      initializeProductsHistoryByLaverie(laverieId);
      // Init the fileInfo field for previsit file
      getPrevisiteFileInfo(laverieId).then((response) => {
        previsiteFileInfo.value = response.data;
      });

      // Init the fileInfo field for bon install
      getBonInstallFileInfo(laverieId).then((response) => {
        bonInstallFileInfo.value = response.data;
      });
    } else {
      title.value = "Nouvelle laverie";
      initEmptyLaverie();
    }

    // If the account id is passed as a prop, set it on the laverie
    if (props.accountId) {
      laverie.value.accountId = props.accountId;
    }
  } catch (error) {
    // Ignore error as it is handled by the global error handler
  } finally {
    loading.value = false;
  }
});
</script>
<style scoped>
.file-list-container {
  border-radius: 8px;
  overflow: hidden;
}

.file-list-item {
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  transition: background-color 0.2s ease;
}

.file-list-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.file-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-label {
  font-weight: 500;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  min-width: 120px;
}

.file-link {
  color: rgb(var(--v-theme-primary));
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
}

.file-link:hover {
  text-decoration: underline;
}

.file-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.file-link-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.no-files {
  text-align: center;
  padding: 32px;
  color: rgba(var(--v-theme-on-surface), var(--v-disabled-opacity));
}

.preview-frame {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 4px;
}

.unsupported-preview {
  text-align: center;
  padding: 40px 20px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .file-item-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .file-label {
    min-width: auto;
  }

  .file-link {
    max-width: 200px;
  }
}
</style>
